import React from 'react'

const ProcessRequest = () => {
    return (
        <div>Coming soon</div>
    )
}

export default ProcessRequest